module.exports = __webpack_public_path__ + "img/kids.7c812538.png";